export default function SourceCats(props: any) {

    const {srcCats} = props

    return (
        <>
            <label htmlFor="src-cat-ids" className="label-heading">Source categories</label>
            <input
                id="src-cat-ids"
                name="src-cat-ids"
                className="readonly-input"
                type="text"
                // onChange={handleChange}
                // value={formData.email}
                value={srcCats}
                readOnly
            />
        </>
    )

}